import { ButtonText, Col, Icon, Row } from "@visa/vds"
import { VSTS_BUTTON_STATE } from "_constants/DashboardConstants";
import { AuthenticatedExternalUserRoutes, GETTING_STARTED } from "_constants/PageRoutes";
import { useAuthContextUser } from "context/AuthContext";
import { ProductSelectionConst } from "pages/3DSStore/PurchaseProduct/Components/SelectProduct/ProductSelectionLogic";
import React, { useEffect } from "react"
import { useHistory } from "react-router-dom";

const VstsAccordionActionItems = (props) => {
    const history = useHistory();
    const user = useAuthContextUser();
    const isSubscriptionManager = user && user.isSubscriptionManager;

    useEffect(() => {
    }, [props.vstsButtonState]);
    
    return (
        <>
            <Row className="vsts-vstt-header-row">
                <Col className="vsts-vstt-link" s={2} md={2} lg={6} xl={6}>
                    <a id="vsts_certification_guide_and_checklist_text" className="cursor-pointer text-decoration-none" onClick={() => history.push(GETTING_STARTED)} >
                        <Icon name="glossary" resolution="low" /> Getting Started Guide
                    </a>
                </Col>
                <Col textAlign="right" s={3} md={3} lg={3} xl={3}>
                    <ButtonText
                        id="purchases_VSTS_btn"
                        disabled={!isSubscriptionManager}
                        onClick={() => history.push({
                            pathname: AuthenticatedExternalUserRoutes.STORE_PURCHASE,
                            state: {
                                selectedProduct: ProductSelectionConst.VSTS_CATEGORY
                            }
                        })} className="width-full button-text" >Purchase VSTS Subscription</ButtonText>
                </Col>
            </Row>
        </>
    )
}

export default VstsAccordionActionItems